import moment from "moment";
import store from '@/store';
export default {
    name: "Chats",
    components: {},
    created() {
        this.loginDetails = localStorage.getItem("currentUser-client");
        if (
            this.loginDetails != "null" &&
            this.loginDetails != null &&
            this.loginDetails != "" &&
            this.loginDetails != "[object Object]"
        ) {
            this.loginDetails = JSON.parse(this.loginDetails);
        } else {
            window.location.href = "/Login";
        }
        this.form.Sender_type = store.Sender_type;
        this.UserTypes = store.UserTypes;
        this.GetOffices();
        this.UserTypesOffies = store.OfficeUserType;
        window.scrollTo(0, 0);
        this.GetAllChatsInfo();
        setInterval(() => this.GetLastMessages(), 5000);
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format("MMMM Do YYYY, h:mm a");
        },
    },

    data() {
        return {
            Info: [],

            UserTypesOffies: [],
            ChatsInfo: [],
            AdminId: 0,
            userId: 0,
            UserTypes: [],
            UserTypeid: null,
            type: '',
            OfficeId: null,
            Offices: [],
            UserType: null,
            infoUsers: [],
            SearchName: '',
            AdminInfo: [],
            loginDetails: null,
            SearchBy: [{
                id: 1,
                name: " بحت بالمستخدمين"
            }, {
                id: 2,
                name: "بحت بالصفة"
            }],
            SearchModel: null,
            selectedName: "",

            form: {
                Received_type: "",
                Sender_type: "",
                offiesUserId: "",
                MessageContent: "",
                FileName: "",
                FileBase64: "",
                Filetype: "",
                ContentType: 0, //0 text 1 pdf
            },
        };
    },
    mounted() {
        this.ScrollToButton();
    },
    methods: {
        userTypeTexts(userTypeObj) {
            const userType = store.OfficeUserType.find(type => type.id === userTypeObj.userType);
            if (userType) {
                if (userType.id === 3 || userType.id === 4) {
                    return ` ${userType.name} `;
                } else {
                    return ` ${userType.name}`;
                }
            }
        },
        SelectedSearch() {

            this.SearchName = null;
            this.OfficeId = null;
            this.UserType = null;
        },
        Back() {

            this.SearchModel = null;
            this.SearchName = null;
            this.OfficeId = null;
            this.UserType = null;
            this.GetAllChatsInfo();

        },
        ScrollToButton() {
            var messageBody = document.querySelector(".msg_history");
            messageBody.scrollTop =
                messageBody.scrollHeight - messageBody.clientHeight;
        },
        GetOffices() {

            this.$blockUI.Start();
            this.$http.GetOffice().then(response => {
                this.$blockUI.Stop();
                this.Offices = response.data.offices;
            })
                .catch(error => {
                    this.$blockUI.Stop();
                    this.$notify({

                        dangerouslyUseHTMLString: true,
                        type: "error",
                        message: error.response.data,
                    });

                })
        },

        GetAllChatsInfo() {
            if (this.SearchModel == 1) {
                if (!this.SearchName) {
                    this.$blockUI.Stop();
                    this.$message({
                        type: 'error',
                        message: 'الرجاء إدخال الاسم'
                    });
                    return;
                }




            }
            else if (this.SearchModel == 2) {
                if (!this.UserType) {
                    this.$blockUI.Stop();
                    this.$message({
                        type: 'error',
                        message: 'الرجاء  اختيار الصفة'
                    });
                    return;
                }
            }
            var Object = {};
            this.$blockUI.Start();
            // searching .... 

            if (this.UserType == 3) {
                this.OfficeId = this.UserTypeid;
            }
            Object = {
                SearchType: this.SearchModel,
                SearchName: this.SearchName,
                UserType: this.UserType,
                OfficeId: this.OfficeId,
                Sender_type: this.form.Sender_type,
            };
            this.$http
                .GetAllChatsInfo(Object)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.infoUsers = response.data.infoUsers;
                    this.AdminInfo = response.data.adminInfo;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        SelectMessage(id, name, Received_type, type, nameTrainers) {
            this.type = type;

            if (name != null) {
                this.selectedName = name;
            }
            else {
                this.selectedName = nameTrainers;
            }

            this.form.Received_type = Received_type;

            this.$blockUI.Start();
            this.$http
                .GetChatsById(id, this.form.Received_type, this.form.Sender_type)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.form.MessageContent = "";
                    this.form.FileBase64 = "";
                    this.form.FileName = "";
                    this.form.ContentType = 0;
                    if (type == 'offies') {
                        this.form.offiesUserId = id;
                        this.AdminId = id;
                        this.userId = id;
                    }
                    else if (type == 'Admin') {
                        this.form.offiesUserId = id;
                        this.AdminId = id;
                        this.userId = id;
                    }
                    else {
                        this.form.offiesUserId = id;
                        this.AdminId = id;
                        this.userId = id;
                    }

                    this.ChatsInfo = response.data.info;
                    this.GetAllChatsInfo();
                    this.$nextTick(() => {
                        // Scroll Down
                        this.ScrollToButton();
                    });
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },


        GetLastMessages() {
            this.$http
                .GetChatsById(this.form.offiesUserId, this.form.Received_type, this.form.Sender_type)
                .then((response) => {
                    this.ChatsInfo = response.data.info;

                });
        },

        FileChanged(event) {
            debugger;
            var files = event.target.files;

            if (files.length <= 0) {
                return;
            }

            //if (files[0].type !== "application/pdf") {
            //  this.$message({
            //    type: "error",
            //    message: "يجب ان يكون الملف من نوع  PDF",
            //  });
            //}
            if (files[0].type !== 'image/jpeg' && files[0].type !== 'image/png' && files[0].type !== 'application/pdf' && files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && files[0].type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                this.$message({
                    type: 'error',
                    dangerouslyUseHTMLString: true,
                    duration: 5000,
                    message: 'عفوا يجب انت تكون الملف من نوع JPG ,PNG,pdf,docx,xlsx'
                });

                return;
            }
            var $this = this;
            var reader = new FileReader();
            console.log(reader);
            reader.onload = function () {
                $this.form.FileName = files[0].name;
                $this.form.FileBase64 = reader.result;
                $this.form.ContentType = 1;
                $this.form.Filetype = files[0].type;
                $this.SendMessage();
            };


            reader.onerror = function () {
                $this.form.FileName = null;
                $this.form.FileBase64 = null;
            };

            this.form.ContentType = 1;

            reader.readAsDataURL(files[0]);


        },

        SendMessage() {
            if (!this.form.offiesUserId) {
                this.$notify({
                    title: " يرجي تحديد الشخص الذي تحاول الارسال اليه",
                    dangerouslyUseHTMLString: true,
                    type: "error",
                });
                return;
            }

            if (!this.form.FileBase64 && !this.form.MessageContent) {
                return;
            }

            const temp = {
                id: null,
                offiesUserId: this.form.offiesUserId,
                sendBy: null,
                user: this.loginDetails.loginName,
                message: this.form.MessageContent,
                createdOn: 0,
                isRead: false,
                status: 2,
                contentType: this.form.ContentType,
                MessageContent: this.form.MessageContent,
                FileBase64: this.form.FileBase64,
                FileName: this.form.FileName,
                ContentType: this.form.ContentType,
                Filetype: this.form.Filetype,
                Received_type: this.form.Received_type,
                Sender_type: this.form.Sender_type,
            };

            if (this.form.ContentType == 1) {
                temp.message = this.form.FileName;
            }

            this.ChatsInfo.push(temp);
            this.form.MessageContent = "";
            this.form.FileBase64 = null;
            this.form.FileName = null;
            this.form.ContentType = 0;
            //after v-for complete
            this.$nextTick(() => {
                // Scroll Down
                this.ScrollToButton();
            });

            //this.$blockUI.Start();
            this.$http
                .SendMessage(temp)
                .then((response) => {
                    debugger;
                    this.ChatsInfo.splice(-1, 1);
                    this.ChatsInfo.push(response.data.info);
           
                    //after v-for complete
                    this.$nextTick(() => {
                        // Scroll Down
                        this.ScrollToButton();
                    });
                })
                .catch((err) => {
                    //this.$blockUI.Stop();
                    this.$notify({
                        title:
                            "خطأ بعملية الارسال يرجي تحديد الشخص الذي تحاول الارسال اليه",
                        dangerouslyUseHTMLString: true,
                        type: "error",
                        message: err.response.data,
                    });
                });
        },
    },
};
